import { z } from "zod";

const environmentSchema = z.object({
  VITE_SUPABASE_URL: z.url({ protocol: /^https?$/v }),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().regex(/^sb_publishable_[\w\-]+$/v),
  // WHY: a build without the VAPID public key (CI, previews) still works; it offers no web push.
  VITE_VAPID_PUBLIC_KEY: z
    .string()
    .regex(/^B[\w\-]{86}$/v)
    .optional(),
});

export type Environment = z.infer<typeof environmentSchema>;

export const parseEnvironment = (source: Readonly<Record<string, unknown>>): Environment => {
  const result = environmentSchema.safeParse(source);
  if (!result.success) {
    throw new TypeError(`Invalid environment: ${z.prettifyError(result.error)}`);
  }
  return result.data;
};
